import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { PendingApproval } from "@/api/types";

const KEYS = {
  pending: ["approvals", "pending"] as const,
};

export function usePendingApprovals() {
  return useQuery({
    queryKey: KEYS.pending,
    queryFn: () => api<PendingApproval[]>("/api/v1/approvals/pending"),
    refetchInterval: 15_000,
  });
}

export function useApprove() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api<PendingApproval>(`/api/v1/approvals/${id}/approve`, {
        method: "POST",
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.pending });
    },
  });
}

export function useReject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) =>
      api<PendingApproval>(`/api/v1/approvals/${id}/reject`, {
        method: "POST",
        body: reason ? { reason } : undefined,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.pending });
    },
  });
}
